import { useQuery } from "@tanstack/react-query";
import { API_URL } from '../config/constants';

export interface OutageConfig {
    bannerActive: boolean;
    outagePageActive: boolean;
    bannerTitle: string;
    bannerMessage: string;
    outageVariant: 'planned' | 'unplanned';
    plannedStartDisplay: string;
    plannedEndDisplay: string;
    outageKey: string;
}

const DEFAULT_CONFIG: OutageConfig = {
    bannerActive: false,
    outagePageActive: false,
    bannerTitle: '',
    bannerMessage: '',
    outageVariant: 'planned',
    plannedStartDisplay: '',
    plannedEndDisplay: '',
    outageKey: '',
};

export const useGetOutageConfig = () => {
    return useQuery<OutageConfig>({
        queryKey: ['outage-config'],
        queryFn: async () => {
            try {
                const baseUrl = API_URL.endsWith('/') ? API_URL : `${API_URL}/`;
                const res = await fetch(`${baseUrl}outage-config`);
                if (!res.ok) return DEFAULT_CONFIG;
                return await res.json() as OutageConfig;
            } catch {
                return DEFAULT_CONFIG;
            }
        },
        staleTime: 5 * 60 * 1000,
        refetchInterval: 5 * 60 * 1000,
        retry: false,
    });
};
